import React, { useEffect, useState } from "react";
import { Select, Label } from "@trussworks/react-uswds";
import log from "loglevel";
import { getReportingPeriods } from "../../utils/api/mdmApi";
import { sortReportingPeriodsDescending } from "../../utils/functions";
import "./ReportingPeriodSelector.scss";
import { successResponses } from "../../utils/api/apiUtils";

const ReportingPeriodSelector = ({
  isExport,
  dataTypes,
  reportingPeriodSelectionHandler,
  exportState,
  includeCurrentQuarter = false,
  setLoading = () => {},
}) => {
  const [reportingPeriods, setReportingPeriods] = useState(null);
  const [selectedReportingPeriod, setSelectedReportingPeriod] = useState({});

  useEffect(() => {
    const fetchReportingPeriods = async () => {
      try {
        setLoading(true);
        const resp = await getReportingPeriods({
          excludeCurrentQuarter: !includeCurrentQuarter,
        });

        if (!successResponses.includes(resp.status)) {
          throw new Error(
            `Fetch reporting periods failed with status: ${resp.status}`
          );
        }

        const sortedPeriods = sortReportingPeriodsDescending(resp.data.items);
        // if resp.data is empty this will evaluate to {}
        const mostRecentPeriod = { ...sortedPeriods[0] };
        let curSelectedPeriod = mostRecentPeriod;

        // set selected period to one from export state if it exists
        if (exportState?.reportingPeriodId) {
          curSelectedPeriod = sortedPeriods.find(
            (period) => period.id === exportState.reportingPeriodId
          );
        }

        setReportingPeriods(sortedPeriods);
        setSelectedReportingPeriod(curSelectedPeriod);
        // this reportingPeriodSelectionHandler call sets init selection from dropdown
        reportingPeriodSelectionHandler(curSelectedPeriod);
        setLoading(false);
      } catch (error) {
        log.log("error fetching reporting periods", error);
      }
    };

    fetchReportingPeriods();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const yearQuarterSelectionHandler = (event) => {
    const selectedId = Number(event.target.value);
    const newSelectedPeriod = reportingPeriods.find(
      (period) => period.id === selectedId
    );
    setSelectedReportingPeriod(newSelectedPeriod);
    reportingPeriodSelectionHandler(newSelectedPeriod);
  };

  return (
    <>
      {reportingPeriods && (
        <div id="reporting-period-wrapper" className="display-flex flex-row">
          <div>
            <Label className="inline-label" htmlFor="year-quarter-dropdown">
              Reporting Periods
            </Label>
            <Select
              id="year-quarter-dropdown"
              name="year-quarter-dropdown"
              className="width-15"
              onChange={yearQuarterSelectionHandler}
              value={selectedReportingPeriod.id}
              disabled={
                isExport &&
                dataTypes.filter((e) => e.checked).length === 1 &&
                dataTypes.find((e) => e.name === "monitoring-plan")?.checked
              }
            >
              {reportingPeriods.map((period) => (
                <option key={period.id} value={period.id}>
                  {period.periodAbbreviation}
                </option>
              ))}
            </Select>
          </div>

          <div className="aria-live margin-x-5">
            <Label htmlFor="reporting-period">Reporting Period</Label>
            <div id="reporting-period" className="padding-top-1">
              <div>
                <strong>Begin Date: </strong>
                {selectedReportingPeriod.beginDate}
              </div>
              <div>
                <strong>End Date: </strong>
                {selectedReportingPeriod.endDate}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ReportingPeriodSelector;
